import { Link, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { ShoppingBag } from "lucide-react";
import { useCart } from "@/context/CartContext";
import { useLang } from "@/context/LanguageContext";
import LangToggle from "@/components/LangToggle";
import logo from "@/assets/logo.png";

export default function Navbar() {
  const { count, setOpen } = useCart();
  const { t } = useLang();
  const [scrolled, setScrolled] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const links = [
    { to: "/", label: t("nav.home"), id: "home" },
    { to: "/shop", label: t("nav.shop"), id: "shop" },
    { to: "/drop", label: t("nav.drop"), id: "drop" },
  ];

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-[background-color,border-color,backdrop-filter] duration-500 ${
        scrolled ? "bg-white/85 backdrop-blur-xl border-b border-slate-200" : "bg-white/40 backdrop-blur-sm border-b border-transparent"
      }`}
    >
      <nav className="mx-auto max-w-[1400px] px-6 md:px-8 h-24 md:h-28 flex items-center justify-between">
        <Link to="/" data-testid="logo-link" className="flex items-center gap-3 group">
          <img src={logo} alt="SlimeGlass" className="h-16 md:h-20 w-auto transition-transform duration-500 group-hover:scale-105" />
        </Link>

        <div className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={`nav-${l.id}`}
              className={`font-mono-x text-xs uppercase tracking-[0.22em] transition-colors duration-300 hover:text-[hsl(var(--accent))] ${
                pathname === l.to ? "text-[hsl(var(--primary))]" : "text-slate-500"
              }`}
            >
              {l.label}
            </Link>
          ))}
        </div>

        <div className="flex items-center gap-3">
        <LangToggle />
        <button
          data-testid="open-cart-btn"
          onClick={() => setOpen(true)}
          className="relative flex items-center gap-2 rounded-full border border-slate-300 bg-white px-4 py-2 hover:border-[hsl(var(--accent))] transition-colors duration-300 group"
        >
          <ShoppingBag className="h-4 w-4 text-slate-700 group-hover:text-[hsl(var(--accent))] transition-colors" />
          <span className="font-mono-x text-xs uppercase tracking-widest text-slate-700 hidden sm:inline">{t("nav.cart")}</span>
          {count > 0 && (
            <span
              data-testid="cart-count"
              className="absolute -top-2 -right-2 h-5 min-w-5 px-1 rounded-full bg-[hsl(var(--accent))] text-white text-[10px] font-bold flex items-center justify-center glow-orange"
            >
              {count}
            </span>
          )}
        </button>
        </div>
      </nav>
    </header>
  );
}
